import dayjs from 'dayjs'

export type FormatType =
  | 'DD MMM YYYY'
  | 'DD MMMM YYYY, HH:mm'
  | 'DD-MM-YYYY'
  | 'YYYY-MM-DD'

export const formatDate = (date: dayjs.ConfigType) => {
  const now = dayjs()
  const target = dayjs(date)
  const yesterday = now.subtract(1, 'day')

  if (target.isSame(now, 'day')) {
    return `Hari ini, ${target.format('HH:mm')}`
  } else if (target.isSame(yesterday, 'day')) {
    return `Kemarin, ${target.format('HH:mm')}`
  } else {
    return target.locale('id').format('DD MMMM YYYY, HH:mm')
  }
}
export function defaultPeriodDate(days = 7) {
  const period = new Date()
  const endDate = period.getTime()
  const startDate = period.getTime() - days * 24 * 60 * 60 * 1000

  return {
    start_date: dayjs(startDate).locale('id').format('YYYY-MM-DD'),
    end_date: dayjs(endDate).locale('id').format('YYYY-MM-DD')
  }
}

export const getDateTimeNow = () => dayjs().locale('id')

export const formatDateShortMonth = (date: dayjs.ConfigType) =>
  dayjs(date).locale('id').format('DD MMM YYYY')

export const formatDMYDash = (date: dayjs.ConfigType) =>
  dayjs(date).locale('id').format('DD-MM-YYYY')

export const formatYMDDash = (
  date: dayjs.ConfigType,
  format?: dayjs.OptionType
) => dayjs(date, format).locale('id').format('YYYY-MM-DD')

export const formatYMDHMSDash = (
  date: dayjs.ConfigType,
  format?: dayjs.OptionType
) => dayjs(date, format).locale('id').format('YYYY-MM-DD HH:mm:ss')

export const getHourMinute = (date: dayjs.ConfigType) =>
  dayjs(date).locale('id').format('HH:mm')

export const formatDateLongMonth = (date: dayjs.ConfigType) =>
  dayjs(date).locale('id').format('DD MMMM YYYY')

export const formatHourMinute = (date: dayjs.ConfigType) =>
  dayjs(date).locale('id').format('HH:mm')

export const formatDMYWithTime = (
  date: dayjs.ConfigType,
  formatType: FormatType
) => dayjs(date).locale('id').format(formatType)

export const dateTimeToUnix = (date: dayjs.ConfigType) =>
  dayjs(date).locale('id').unix()

export const formatDateLongMonthHourMinute = (date: dayjs.ConfigType) =>
  dayjs(date).locale('id').format('DD MMMM YYYY HH:mm')

export const defaultPeriodThisMonth = () => {
  const now = dayjs().locale('id')
  const startDate = now.startOf('month').format('YYYY-MM-DD')
  const endDate = now.endOf('month').format('YYYY-MM-DD')

  return { start_date: startDate, end_date: endDate }
}

export const getDiffOfDays = (
  start_date: dayjs.ConfigType,
  end_date: dayjs.ConfigType
) => Math.abs(dayjs(end_date).diff(start_date, 'day'))

export const unixToDayJs = (date: number) => {
  return dayjs.unix(date).locale('id')
}

export const formatFromNow = (date: dayjs.ConfigType) => {
  return dayjs(date).locale('id').fromNow()
}
